import { render } from "./SettingsWrapper.vue?vue&type=template&id=611c11aa"
import script from "./SettingsWrapper.vue?vue&type=script&lang=js"
export * from "./SettingsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/settings/SettingsWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "611c11aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('611c11aa', __exports__)) {
    api.reload('611c11aa', __exports__)
  }
  
  module.hot.accept("./SettingsWrapper.vue?vue&type=template&id=611c11aa", () => {
    api.rerender('611c11aa', render)
  })

}


export default __exports__